import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getIsJobLaborTrackingEnabled } from 'lib/selectors/getIsJobLaborTrackingEnabled';
import { LaborTicketSignInModal } from './LaborTicketSignInModal';
import { SignInModal } from './SignInModal';

const SignInModalWrapper = ({ operator, onClose, onSubmit, isOpen }) => {
  const isJobLaborTrackingEnabled = useSelector(getIsJobLaborTrackingEnabled);

  if (isJobLaborTrackingEnabled) {
    return (
      <LaborTicketSignInModal
        operator={operator}
        onClose={onClose}
        onSubmit={onSubmit}
        isOpen={isOpen || !!operator}
      />
    );
  }

  return (
    <SignInModal
      operator={operator}
      onClose={onClose}
      onSubmit={onSubmit}
      isOpen={isOpen || !!operator}
    />
  );
};

SignInModalWrapper.propTypes = {
  operator: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isOpen: PropTypes.bool,
};

export { SignInModalWrapper };
